import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";
import qs from "qs"
import { snakeCase } from "lodash";

//Since I do not have better plurialize
const plurialize = (str) => (`${str}s`)

const configurationUrlPrefix = ( { remote_configurable_type, remote_configurable_id } ) => {
  let url = ""
  if ( remote_configurable_type && remote_configurable_id ) {
    url = `${plurialize(snakeCase(remote_configurable_type))}/${remote_configurable_id}/sdk`
  } else {
    url = "default_configuration/sdk"
  }
  return url
}

const tagFromRemoteConfiguration = ({remote_configurable_type, remote_configurable_id}) => {
  if ( !remote_configurable_type || remote_configurable_type=="OsType") {
    return "default"
  } else {
    return `${remote_configurable_type}:${remote_configurable_id}`
  }
}

export const remoteConfigurationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getGlobalRemoteConfiguration: builder.query({
      query: () => ({
        url: 'sdk/remote_configurations'
      }),
      providesTags: (result = [], error, arg) => [{ type: 'RemoteConfiguration', id: 'default' }],
    }),
    getConfigurableRemoteConfiguration: builder.query({
      query: (configuration) => ({
        url: configurationUrlPrefix(configuration) + "/remote_configuration"
      }),
      providesTags: (result = [], error, arg) => [
        { type: 'RemoteConfiguration', id: tagFromRemoteConfiguration(arg) }
      ],
    }),
    getConfigurableRemoteConfigurationHistory: builder.query({
      query: (configuration) => ({
        url: configurationUrlPrefix(configuration) + "/remote_configuration/history"
      }),
      providesTags: (result = [], error, arg) => [
        { type: 'RemoteConfigurationHistory', id: tagFromRemoteConfiguration(arg) }
      ],
    }),
    createRemoteParam: builder.mutation({
      query: ( { configuration, remoteParam } ) => ({
        url: configurationUrlPrefix(configuration) + "/remote_params",
        method: 'POST',
        body: remoteParam
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.created")}),
      invalidatesTags: (result, error, {configuration}) => {
        return [
          { type: 'RemoteConfiguration', id: tagFromRemoteConfiguration(configuration)},
          { type: 'RemoteConfigurationHistory', id: tagFromRemoteConfiguration(configuration)}
        ]
      }
    }),
    updateRemoteParam: builder.mutation({
      query: ( { configuration, remoteParam } ) => {
      return {
        url: configurationUrlPrefix(configuration) + `/remote_params/${remoteParam.id}`,
        method: 'PUT',
        body: remoteParam
      }},
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, {configuration}) => {
        return [
          { type: 'RemoteConfiguration', id: tagFromRemoteConfiguration(configuration)},
          { type: 'RemoteConfigurationHistory', id: tagFromRemoteConfiguration(configuration)}
        ]
      }
    }),
    deleteRemoteParam: builder.mutation({
      query: ( { configuration, remoteParam } ) => ({
        url: configurationUrlPrefix(configuration) + `/remote_params/${remoteParam.id}`,
        method: 'DELETE'
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.deleted")}),
      invalidatesTags: (result, error, {configuration}) => {
        return [
          { type: 'RemoteConfiguration', id: tagFromRemoteConfiguration(configuration)},
          { type: 'RemoteConfigurationHistory', id: tagFromRemoteConfiguration(configuration)}
        ]
      }
    })
  })
})

export const {
  useGetGlobalRemoteConfigurationQuery,
  useGetConfigurableRemoteConfigurationQuery,
  useGetConfigurableRemoteConfigurationHistoryQuery,
  useCreateRemoteParamMutation,
  useUpdateRemoteParamMutation,
  useDeleteRemoteParamMutation
} = remoteConfigurationApiSlice